import { render, staticRenderFns } from "./QuoteGrid.vue?vue&type=template&id=6bf106b6"
import script from "./QuoteGrid.vue?vue&type=script&lang=js"
export * from "./QuoteGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports